angular.module('FmsApp').controller("ViewFarmProfileController", ["$scope", "FarmProfileFactory", "farm_slug", "$filter",
    function ($scope, FarmProfileFactory, farm_slug, $filter) {
        $scope.dialogTitle = $filter('translate')('farmDetails.farm_profile');
        $scope.profile = FarmProfileFactory.get({farm_slug: farm_slug, view_only: "yes"},
            function (result) {
                $scope.profile = result;
            });
    }]);